export const locale = {
  lang: 'en-CA',
  data: {
    CHAT: {
      TITLE: 'Chat',
      CHATS: 'Conversations',
      SEARCH: 'Search',
      NO_RESULTS: 'No results…',
      NEW_CONVERSATION: 'New conversation',
      SELECT_CONVERSATION: 'Select a conversation to get started',
      TYPE_MESSAGE: 'Type your message…',
      LOCKED: 'This conversation is locked',
      DELETED_MESSAGE: 'Message deleted',
      ATTACHMENT: 'Attachment',
      EDITED: '(edited)',
      SEND_FAILED: 'Send failed',
      RETRY: 'Retry',
      REPLY: 'Reply',
      EDIT: 'Edit',
      DELETE: 'Delete',
      PIN: 'Pin',
      UNPIN: 'Unpin',
      MUTE: 'Mute notifications',
      UNMUTE: 'Unmute notifications',
      DIRECT: 'Direct message',
      GROUP: 'Group',
      GROUP_NAME: 'Group name',
      SELECT_USERS: 'Pick coworkers',
      VIEW_CONVERSATIONS: 'View conversations',
      SELECT_ALL: 'Select all',
      DESELECT_ALL: 'Deselect all',
      CREATE: 'Create',
      CANCEL: 'Cancel',
      EDITING: 'Editing message',
      REACT: 'React',
      COPY: 'Copy text',
      COPIED: 'Text copied',
      AND_N_OTHERS: 'and {{count}} more',
      UPLOAD_TOO_MANY: 'Maximum 5 files per message',
      UPLOAD_TOO_BIG: '"{{name}}" exceeds 10 MB',
      UPLOAD_BAD_TYPE: 'File type not accepted: "{{name}}"',
      DROP_HERE: 'Drop files here',
      TYPING_ONE: '{{name}} is typing…',
      TYPING_TWO: '{{a}} and {{b}} are typing…',
      TYPING_MANY: 'Several people are typing…',
      PINNED_TITLE: 'Pinned messages',
      NO_PINNED: 'No pinned messages',
      NEW_MESSAGES: 'New messages',
      DELETE_MESSAGE_CONFIRM: 'Delete this message?',
      ONLINE: 'Online',
      START_HINT: 'Select a colleague to start a conversation',
      MENTION_FALLBACK: 'User',
      MENTION_ALL_HINT: 'Notify all participants',
      MENTIONED_YOU: 'You were mentioned',
      SEARCH_RESULTS: 'Results in messages',
      IN_THIS_CONVERSATION: 'In this conversation',
      SYSTEM: {
        conversation_created: 'Conversation created',
        conversation_renamed: 'The conversation was renamed',
        participant_joined: 'A participant joined the conversation',
        participant_left: 'A participant left the conversation',
        participants_added: 'Participants were added',
        participant_removed: 'A participant was removed',
      },
    },
  },
};
